import CloseIcon from "./CloseIcon";

// When we add more arrows, change this to named exports
export default CloseIcon;
